module.exports = __webpack_public_path__ + "img/ancient.b62ba43b.png";